import { ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfigService } from '../../services/config/config.service';
import { TermsAndConditionsService } from '../../services/terms-and-conditions/terms-and-conditions.service';
import { AuthService } from '../../services/auth/auth.service';
var FooterComponent = /** @class */ (function () {
    function FooterComponent(configService, termsAndConditionsService, authService) {
        this.termsAndConditionsService = termsAndConditionsService;
        this.authService = authService;
        this.currentUser = null;
        this.destroy$ = new Subject();
        this.environment = configService.config.environment;
        this.productName = configService.config.productName;
        this.version = configService.config.version;
        this.year = new Date().getFullYear();
        this.termsAndConditionsService.shown.subscribe(function () {
            /*this.termsAndConditionsButton.nativeElement.click();*/
        });
    }
    Object.defineProperty(FooterComponent.prototype, "showCouncilSupportEmail", {
        get: function () {
            return !!this.currentUser && this.currentUser.isInRole("council");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterComponent.prototype, "showJjrSupportEmail", {
        get: function () {
            return !!this.currentUser && this.currentUser.isInRole("jjr");
        },
        enumerable: true,
        configurable: true
    });
    FooterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authService.userInfoSubject
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (user) {
            _this.currentUser = user;
        });
    };
    FooterComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    return FooterComponent;
}());
export { FooterComponent };
